"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_SETTINGS_VERSION_LATEST = exports.APP_SETTINGS_VERSION_4 = exports.APP_SETTINGS_VERSION_3 = exports.APP_SETTINGS_VERSION_2 = exports.APP_SETTINGS_VERSION_1 = exports.APP_SETTINGS_VERSION_0 = void 0;
exports.APP_SETTINGS_VERSION_0 = 0;
exports.APP_SETTINGS_VERSION_1 = 1;
exports.APP_SETTINGS_VERSION_2 = 2;
exports.APP_SETTINGS_VERSION_3 = 3;
exports.APP_SETTINGS_VERSION_4 = 4;
exports.APP_SETTINGS_VERSION_LATEST = exports.APP_SETTINGS_VERSION_4;
//# sourceMappingURL=versions.js.map